export default __webpack_public_path__ + "static/media/Deo-Dream.39cb3ce9.jpg";